import { FC } from 'react';

import { TitleList } from '@components/media';
import { SimpleTitle } from '@models/Title';
import useSearchAndFilter from '@modules/layouts/hooks/useSearchAndFilter';
import { SearchCardActionProps } from '@modules/search/components/SearchResult/SearchGrid/SearchResultCard';

type SearchListProps = {
  actions?: FC<SearchCardActionProps>;
  onSelect?: (simpleTitle: SimpleTitle) => void;
};

const SearchList: FC<SearchListProps> = ({ actions, onSelect }) => {
  const {
    searchQuery: { indexName },
    queryResult: { isLoading, titles: { data = [] } = {} },
  } = useSearchAndFilter();

  return (
    <TitleList
      actions={actions}
      indexName={indexName}
      isLoading={isLoading}
      onSelect={onSelect}
      titles={data.map(item => ({ ...item.value }))}
    />
  );
};

export default SearchList;
